import datalayerPushGeneric from '@utils/DataLayerPushGeneric';

function init() {
  addEventListeners();
}

function addEventListeners() {
  dataLayer();
}

function dataLayer() {
  document.addEventListener('click', (e) => {
    if (e.target.hasAttribute('data-au-datalayer')) {
      datalayerPushGeneric(e);
    }
  });
}

export default { init };
